export enum ReturnStatus {
  started = "started",
  complete = "complete",
  partial = "partial-refund",
  keptInStore = "kept_in_store",
  expired = "expired",
  droppedOff = "dropped-off"
}
